<div class="create-calculation-wrapper">
  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>
  <app-create-calculation-form
    [backRoute]="'/public/dashboard'"
    [submitting]="submitting"
    (cancel)="onCancel()"
    (calculationCreated)="onCalculationCreated($event)"
    (invoiceUploaded)="onInvoiceUploaded($event)"
  ></app-create-calculation-form>
</div>
